/* Mrays — journal listing: search, category filter, render.
   Reads BLOG_POSTS from blog-data.js. No backend — everything
   runs against the in-memory array. */

(function () {
  'use strict';

  var dataEl = document.getElementById('blog-articles-data');
  if (!dataEl) return;
  var BLOG_POSTS = JSON.parse(dataEl.textContent);

  var CAT_LABEL = {
    screens: 'Screens & displays',
    battery: 'Battery & charging',
    water: 'Water damage',
    data: 'Data & software',
    advice: 'Buying advice',
    shop: 'From the shop'
  };

  var posts = BLOG_POSTS.slice().sort(function (a, b) {
    return new Date(b.date) - new Date(a.date);
  });

  var featuredEl = document.getElementById('jFeatured');
  var gridEl = document.getElementById('jGrid');
  var emptyEl = document.getElementById('jEmpty');
  var countEl = document.getElementById('jResultsCount');
  var searchForm = document.getElementById('blogSearch');
  var searchInput = document.getElementById('blogSearchInput');
  var searchClear = document.getElementById('blogSearchClear');
  var catButtons = Array.prototype.slice.call(document.querySelectorAll('.jcats__btn'));
  var resetBtn = document.getElementById('jResetSearch');

  var state = { query: '', cat: 'all' };

  function fmtDate(d) {
    var date = new Date(d + 'T00:00:00');
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function matches(post, query) {
    if (!query) return true;
    var haystack = [post.title, post.excerpt, post.category, CAT_LABEL[post.category], post.author]
      .concat(post.tags || [])
      .join(' ')
      .toLowerCase();
    return query.toLowerCase().split(/\s+/).filter(Boolean).every(function (word) {
      return haystack.indexOf(word) !== -1;
    });
  }

  function cardHTML(post) {
    return (
      '<article class="jcard reveal">' +
        '<a class="jcard__link" href="' + post.url + '">' +
          '<div class="jcard__media">' +
            '<img src="' + post.image + '" alt="" loading="lazy">' +
            '<span class="jcard__cat">' + CAT_LABEL[post.category] + '</span>' +
          '</div>' +
          '<div class="jcard__body">' +
            '<p class="jcard__meta">' + fmtDate(post.date) + ' &middot; ' + post.readMins + ' min read</p>' +
            '<h3 class="jcard__title">' + post.title + '</h3>' +
            '<p class="jcard__excerpt">' + post.excerpt + '</p>' +
            '<span class="jcard__more">Read the guide' +
              '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 12L12 4M12 4H6M12 4v6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/></svg>' +
            '</span>' +
          '</div>' +
        '</a>' +
      '</article>'
    );
  }

  function featuredHTML(post) {
    return (
      '<a class="jfeatured__card reveal" href="' + post.url + '">' +
        '<div class="jfeatured__media">' +
          '<img src="' + post.image + '" alt="" loading="lazy">' +
          '<span class="jcard__cat">' + CAT_LABEL[post.category] + '</span>' +
        '</div>' +
        '<div class="jfeatured__body">' +
          '<p class="eyebrow">Latest guide</p>' +
          '<h2 class="jfeatured__title">' + post.title + '</h2>' +
          '<p class="jfeatured__excerpt">' + post.excerpt + '</p>' +
          '<p class="jcard__meta">' + fmtDate(post.date) + ' &middot; ' + post.readMins + ' min read &middot; ' + post.author + '</p>' +
        '</div>' +
      '</a>'
    );
  }

  function render() {
    var showFeatured = !state.query && state.cat === 'all';
    var pool = posts.filter(function (p) {
      var catOk = state.cat === 'all' || p.category === state.cat;
      return catOk && matches(p, state.query);
    });

    featuredEl.innerHTML = '';
    featuredEl.hidden = !showFeatured || pool.length === 0;

    var listPool = pool;
    if (showFeatured && pool.length) {
      featuredEl.innerHTML = featuredHTML(pool[0]);
      listPool = pool.slice(1);
    }

    gridEl.innerHTML = listPool.map(cardHTML).join('');
    emptyEl.hidden = pool.length !== 0;

    if (pool.length === 0) {
      countEl.textContent = '';
    } else if (state.query) {
      countEl.textContent = pool.length + (pool.length === 1 ? ' post' : ' posts') + ' for “' + state.query + '”';
    } else if (state.cat !== 'all') {
      countEl.textContent = pool.length + (pool.length === 1 ? ' post' : ' posts') + ' in ' + CAT_LABEL[state.cat];
    } else {
      countEl.textContent = pool.length + ' posts';
    }

    searchClear.hidden = !state.query;

    // re-run reveal-on-scroll for freshly injected cards
    if (window.mraysRevive) window.mraysRevive();
  }

  searchForm.addEventListener('submit', function (e) { e.preventDefault(); });
  searchInput.addEventListener('input', function () {
    state.query = searchInput.value.trim();
    render();
  });
  searchClear.addEventListener('click', function () {
    state.query = '';
    searchInput.value = '';
    searchInput.focus();
    render();
  });

  catButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.cat = btn.dataset.cat;
      catButtons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
      });
      render();
    });
  });

  resetBtn.addEventListener('click', function () {
    state.query = ''; state.cat = 'all';
    searchInput.value = '';
    catButtons.forEach(function (b, i) {
      b.classList.toggle('is-active', i === 0);
      b.setAttribute('aria-selected', String(i === 0));
    });
    render();
  });

  // support ?q= deep links (e.g. from a future search box elsewhere on the site)
  var params = new URLSearchParams(window.location.search);
  if (params.get('q')) {
    state.query = params.get('q');
    searchInput.value = state.query;
  }

  render();
})();
